/** Racine des routes de la boutique virtuelle. */
export const ROUTE_BASE = '/boutique';

/** Clé de persistance versionnée (cf. cahier des charges §12). */
export const STORAGE_KEY = 'chienheureux:virtual-shop:v1';

/** Sortie vers le site e-commerce classique, toujours disponible. */
export const CLASSIC_SHOP_URL =
  import.meta.env.VITE_CLASSIC_SHOP_URL ?? 'https://www.chien-heureux.fr';

/** Nombre d'os à retrouver pour terminer la mini-quête. */
export const TOTAL_BONES = 3;

/** Durée par défaut d'affichage d'une réplique, en millisecondes. */
export const DIALOGUE_DURATION_MS = 5200;

/** Délai d'inactivité avant de suggérer discrètement les hotspots. */
export const IDLE_HINT_DELAY_MS = 9000;
